import LunchTrackingView from "@/components/dashboard/parent/LunchTrackingView";

export default function ParentLunchUpdates() {
  return <LunchTrackingView />;
}
